module.exports = __webpack_public_path__ + "img/logo.def8e8d0.png";